import React from 'react';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import {
  getManualSenderRemissionGuide,
  putRefreshSenderRemissionGuide,
} from '../../../../actions/cargo/ManualSenderRemissionGuide';

const RefreshManualSenderRemissionGuideButton = (props) => {
  const {
    manualRemissionGuide,
    dispatchPutRefreshSenderRemissionGuide,
    dispatchGetSenderRemissionGuide,
  } = props;

  const refreshSenderRemissionGuide = async () => {
    const response = await dispatchPutRefreshSenderRemissionGuide(
      manualRemissionGuide.get('id'),
    );

    if (response) {
      dispatchGetSenderRemissionGuide({
        SenderRemissionGuideId: manualRemissionGuide.get('id'),
      });
    }
  };

  return (
    <Button
      color="info"
      className="border"
      onClick={refreshSenderRemissionGuide}
    >
      <i className="fa fa-refresh" /> Revisar Estado de Facturación
    </Button>
  );
};

RefreshManualSenderRemissionGuideButton.propTypes = {
  manualRemissionGuide: PropTypes.instanceOf(Immutable.Map).isRequired,
  dispatchPutRefreshSenderRemissionGuide: PropTypes.func.isRequired,
  dispatchGetSenderRemissionGuide: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPutRefreshSenderRemissionGuide: putRefreshSenderRemissionGuide,
  dispatchGetSenderRemissionGuide: getManualSenderRemissionGuide,
};

export default connect(
  null,
  mapDispatchToProps,
)(RefreshManualSenderRemissionGuideButton);
